import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import searchbar from "./searchbar.module.css";
import basestyles from "../../styles/basestyles.module.css";
import DocData from "../DocData/docdata.json";
import DoctorsNearby from "../DoctorsNearby/DoctorsNearby";

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      docData: DocData,
    };
  }

  filterData = () => {
    if (this.state.search.length >= 3) {
      let filteredItems = this.state.docData.filter((doc) => {
        let currentDoctor = Object.values(doc).toString().toLowerCase();
        return currentDoctor.includes(this.state.search.toLowerCase());
      });
      this.setState({ docData: filteredItems });
    } else {
      this.setState({ docData: DocData });
    }
  };

  updateSearch = (event) => {
    this.setState({ search: event.target.value }, () => this.filterData());
  };

  selectDoctor = (doctor) => {
    delete doctor.ZipCode;
    delete doctor.City;
    delete doctor.State;
    localStorage.setItem("doctor_selected", JSON.stringify(doctor));
    toast.info("Doctor selected.");
  };

  render() {
    return (
      <div className={basestyles.inputWidth}>
        <div className={searchbar.inputicon}>
          <h4>Enter Your City, State or Zip Code to find Doctor's near you</h4>
          <label className={searchbar.searchlabel} htmlFor="search-input">
            <input
              type="text"
              name="Search"
              id="search-input"
              placeholder="Enter Zip Code or City or State or Doctor's Name"
              value={this.state.search}
              onChange={this.updateSearch}
            />
            <i className={`fa fa-search ${searchbar.searchicon}`}></i>
          </label>
          {this.state.docData.map((doctor) => {
            return (
              <div className={searchbar.doctorlist}>
                <DoctorsNearby
                  doctor={doctor}
                  selectDoctor={this.selectDoctor}
                />
              </div>
            );
          })}
        </div>
        <ToastContainer autoClose={false} />
      </div>
    );
  }
}

export default SearchBar;
